// Where the frontend sends its API calls.
//
// 2026-10-10: the backend moved off Render's free tier (futureshift.onrender.com, which spins
// down and took ~30 s to wake) onto the always-on Mac mini, published through Tailscale Funnel.
// The Vercel project still carries REACT_APP_API_URL=https://futureshift.onrender.com, so a bare
// env read would keep pointing at the retired copy; treat that one value as legacy and use the
// mini. Any other REACT_APP_API_URL value still wins, so a future api.futureshift.ai is one env change.
const RENDER_LEGACY = 'https://futureshift.onrender.com';
const MINI = 'https://homie-mini.tailfb4d63.ts.net:10000';
const LOCAL = 'http://localhost:3001';

const fromEnv = process.env.REACT_APP_API_URL;

export const API_URL =
  fromEnv && fromEnv !== RENDER_LEGACY
    ? fromEnv
    : process.env.NODE_ENV === 'development'
      ? LOCAL
      : MINI;
